<div class="modal">

    <div class="modal__content">
        <div>
            <div class="modal__title">
                <span>Heta Arbeten® PREMIUM</span>
            </div>

            <div class="modal__text">
                <p><em>Heta Arbeten<sup>®</sup> PREMIUM</em> ger ditt företag full kontroll över heta arbeten – med tydlig överblick, ökad säkerhet och smarta funktioner som sparar tid och effektiviserar processen. Med anpassningsbara digitala tillstånd, realtidsstatistik och automatiska notiser samlas allt på ett ställe för tryggare och enklare arbetsflöden.</p>
                <br/>
                <p>Vill du se hur <em>Heta Arbeten<sup>®</sup> PREMIUM</em> kan stärka säkerheten och effektiviteten i din verksamhet? Boka en kostnadsfri demo via knappen nedan.</p>
            </div>
        </div>
        <div class="modal__cta" (click)="openPremiumDemo()">
            <span>Boka demo</span>
        </div>
    </div>
    <div class="modal__actions">
        <button class="modal__actions__close" type="button" (click)="close()">Stäng</button>
    </div>
</div>
